var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelivered = function SvgDelivered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 10,
    fill: "#FFC043"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 7.5h9a.5.5 0 01.5.5v8a.5.5 0 01-.5.5H8a.5.5 0 01-.5-.5V8a.5.5 0 01.5-.5zm8.5 2.119l-3.964 3.55L8.5 9.608V15.5h8V9.619zM8.755 8.5l3.775 3.331L16.252 8.5H8.755z"
  })));
};
export default SvgDelivered;